import { createFileRoute } from '@tanstack/react-router';
import LaneDetailView from '../terminal/LanesView/components/LaneDetailView';
export const Route = createFileRoute('/terminals/lanes/$id')({ component: LaneDetailView });
